<template>
    <div class="scan">

        <el-form  :inline="true" :model='scanSearchForm'  :rules="scanSearchRules" ref="scanSearchForm" class="inline-form"  > 
            <el-row style="width: 100%;">
                <el-col :span="6" >
                    <el-form-item label="设备列表："  prop="deviceId">
                        <el-select v-model="sscannerList" filterable placeholder="请选择"  @change="deviceChange">
                            <el-option v-for="item in deviceList" :key="item.deviceID" :label="item.deviceName" :value="item.deviceID">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="考试列表：" prop="examId" style="width: 100%;" id="form-item-examId">
                        <el-select v-model="scanSearchForm.examId" filterable placeholder="请选择"  @change="examChange" :style="{ width: selectWidth }">
                            <el-option v-for="item in examList" :key="item.id" :label="item.name+'('+item.id+')'" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="6" >
                    <el-form-item >
                        <el-button type="primary" size ="mini" icon="search" :disabled="!canScan" @click='startScan'>扫描</el-button>
                        <el-button type="danger" size ="mini" icon="search"  @click='wxSend' style="margin-left: 20px;">通知服务人员</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
            
        </el-form>


    </div>
  </template>
  
  <script>
  
  
  export default {
    name: 'App',
    components: {
  
    },
    data() {
      return {
        socket: null, userId: 1,
        message: '', connected: false,
        messages: [], scannerList: [], imageList: [],
        scanSearchForm:{
            deviceId: null, 
            examId: null, 
            scanContinue: 0, 
            scanCount: 1,
            last_batch_count:0
        },
      };
    },
    mounted() {
        // 触发连接
      this.initWebSocket();
    //   console.log("触发登陆----------》");
    //   this.printList()
    //   console.log("获取扫描仪列表----------》");
    },
    beforeUnmount() {
      this.closeWebSocket();
    },
    methods: {
      initWebSocket() {
        if(!this.connected){
  
          const socketUrl = 'ws://127.0.0.1:10750/ws';
          this.socket = new WebSocket(socketUrl);
  
          this.socket.onopen = () => {
            console.log('连接后台成功');
            this.connected = true;
          };
  
          this.socket.onmessage = (event) => {
       
            console.log('收到消息', event);
            let eventData = event.data;
            this.messages.push(eventData);
            let jo = JSON.parse(eventData);
            let sType = jo["type"]
            if(sType === "deviceList"){
              let deviceList = jo["data"]
              if(deviceList != null && deviceList.length > 0) this.scannerList = deviceList;
            }else if(sType === "scanImage"){
              this.imageList.push(jo);
            }
          };
  
          this.socket.onclose = () => {
            console.log('WebSocket 连接关闭');
            this.connected = false;
          };
  
          this.socket.onerror = (error) => {
            console.error('WebSocket 错误:', error);
            this.connected = false;
          };
        }
      },
      sendMessage(msg) {
        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
          this.socket.send(msg);
        } else {
          console.error('WebSocket 没有连接到后台');
        }
      },
      closeWebSocket() {
        if (this.socket) {
          this.socket.close();
        }
      },
      registerUser(){
        this.sendMessage(JSON.stringify({type: "register", userId: this.userId}));
      },
      printList(){
        this.sendMessage(JSON.stringify({type: "deviceList"}));
      },
      startScan(){
        this.sendMessage(JSON.stringify({type: "startScan", scannerName: this.scannerList[0]}));
      },
      uploadScan(){
        this.sendMessage(JSON.stringify({type: "uploadScan", scannerName: this.scannerList[0]}));
      },

    }
  }
  </script>
  
  <style>
  .scan{
    width: 100%
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 20px;
  }
  .m-left-20{
    margin-left: 20px;
  }
  .flex-row {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    justify-items: center;
  }
  .image-list {
    width: 48vw;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    justify-items: center;
    flex-wrap: wrap;
  }
  .image-view{
    display: flex;
    flex-direction: column;
    justify-items: center;
    justify-content: center;
   }
  .scan-image{
    width: 150px;
    height: 150px;
  }
  .log-view {
    width: 48vw;
  }

  
  </style>
  